// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3oBil","inner":"Footer_inner__1IOWO"};